import e from "../../hooks/useFocusTrap.js";
import t from "../../hooks/useEsc.js";
import n from "../../utils/classNames.js";
import { getOrCreatePortalRoot as r } from "../../utils/portalRoot.js";
import { DialogContextProvider as i } from "./dialogContext.js";
import a from "./DialogHeader.js";
import o from "./DialogBody.js";
import s from "./DialogFooter.js";
import { useState as c } from "react";
import { noop as l } from "es-toolkit/function";
import { AnimatePresence as u, motion as d, useReducedMotion as f } from "motion/react";
import { Fragment as p, jsx as m, jsxs as h } from "react/jsx-runtime";
import g from "react-dom";
//#region src/components/dialog/Dialog.tsx
var _ = "modal-dialog", v = "modal-open", y = (y) => {
	let { title: b, subtitle: x, body: S, footer: C, headerButtons: w, className: T = "", bodyClassName: E, footerClassName: D, showXsDialogBorders: O = !1, showCloseButton: k = !0, useOverflow: A = !1, bsSize: j, show: M = !1, onClose: N = l, disableEsc: P = !1, onEsc: F = l, onCloseValidation: I = () => !0, children: L, ...R } = y, [z, B] = c(M), V = r(), H = f(), [U, W] = c(null);
	e(U);
	let G = (e) => {
		let t = V.getElementsByClassName(_).length > 1;
		e ? document.body.classList.add(v) : !e && !t && document.body.classList.remove(v);
	}, K = () => q(!0), q = (e) => {
		I() && (B(!1), N(), e && F());
	}, [J, Y] = c(M);
	M !== J && (B(M), G(M), Y(M)), t(() => {
		if (!U) return;
		let e = U, t = document.activeElement;
		!P && e.contains(t) && q(!0);
	});
	let X = (e) => {
		if (e.opacity === 0) return;
		let t = U, n = document.activeElement;
		t?.contains(n) || t?.focus();
	}, Z = n("modal", "show", T), Q = j === "xs", $ = !!L, ee = n(_, A && "modal-overflow", j === "xs" && "modal-xs", j === "sm" && "modal-sm", j === "lg" && "modal-lg", j === "xl" && "modal-xl", j === "full" && "modal-full-width", j === "fullwidth" && "modal-full-width", j === "fullheight" && "modal-full-height", j === "fullheight-lg" && "modal-full-height modal-lg", j === "fullheight-xl" && "modal-full-height modal-xl", j === "fullscreen" && "modal-fullscreen"), te = {
		type: "spring",
		damping: 33,
		stiffness: 500
	}, ne = {
		type: "spring",
		damping: 25,
		stiffness: 400
	};
	return g.createPortal(/* @__PURE__ */ m(i, {
		value: {
			onClose: K,
			isSmallestDialog: Q,
			showXsDialogBorders: O,
			showCloseButton: k
		},
		children: /* @__PURE__ */ m(u, {
			initial: !1,
			mode: "wait",
			children: z && /* @__PURE__ */ h("div", {
				...R,
				className: Z,
				role: "dialog",
				"aria-label": "dialog",
				tabIndex: 0,
				children: [/* @__PURE__ */ m(d.div, {
					initial: !H && {
						opacity: 0,
						y: "-50%"
					},
					animate: H ? { opacity: 1 } : {
						opacity: 1,
						y: 0,
						transition: Q ? ne : te
					},
					exit: H ? void 0 : {
						opacity: 0,
						y: "-150%"
					},
					transition: H ? { duration: 0 } : {
						opacity: { duration: .2 },
						y: { duration: .3 }
					},
					onAnimationComplete: X,
					ref: W,
					className: ee,
					role: "document",
					tabIndex: -1,
					children: /* @__PURE__ */ h("div", {
						className: "modal-content",
						children: [$ && L, !$ && /* @__PURE__ */ h(p, { children: [
							b && /* @__PURE__ */ m(a, {
								title: b,
								subtitle: x,
								headerButtons: w
							}),
							S && /* @__PURE__ */ m(o, {
								className: E,
								children: S
							}),
							C && /* @__PURE__ */ m(s, {
								className: D,
								children: C
							})
						] })]
					})
				}), /* @__PURE__ */ m(d.div, {
					initial: !H && { opacity: 0 },
					animate: { opacity: 1 },
					exit: H ? void 0 : { opacity: 0 },
					transition: H ? { duration: 0 } : { duration: .1 },
					className: "modal-backdrop"
				})]
			})
		})
	}), V);
};
y.Title = a, y.Body = o, y.Footer = s, y.SIZE_XS = "xs", y.SIZE_SM = "sm", y.SIZE_MD = "md", y.SIZE_LG = "lg", y.SIZE_XL = "xl", y.SIZE_FULL = "full", y.SIZE_FULL_WIDTH = "fullwidth", y.SIZE_FULL_HEIGHT = "fullheight", y.SIZE_FULL_HEIGHT_LG = "fullheight-lg", y.SIZE_FULL_HEIGHT_XL = "fullheight-xl", y.SIZE_FULL_SCREEN = "fullscreen";
//#endregion
export { y as default };

//# sourceMappingURL=Dialog.js.map